let navOpen = $('#site-navigation-open'),
    navClose = $('#site-navigation-close'),
    menuOverlay = $('#header-menu-overlay'),
    navContainer = $('#primary-navigation');

function openNav() {
    navContainer.attr('aria-hidden', 'false');
    navOpen.attr('aria-expanded', 'true');
    navClose.attr('aria-expanded', 'true');
    navContainer.addClass('is-open');
    document.body.classList.add('menu-open');
}

function closeNav() {
    navContainer.attr('aria-hidden', 'true');
    navOpen.attr('aria-expanded', 'false');
    navClose.attr('aria-expanded', 'false');
    navContainer.removeClass('is-open');
    document.body.classList.remove('menu-open');
}

navOpen.on('click', function(e) {
    e.preventDefault();
    openNav();
});

navClose.on('click', function(e) {
    e.preventDefault();
    closeNav();
});

menuOverlay.on('click', function(e) {
    e.preventDefault();
    closeNav();
});
